import { Button } from "@fluentui/react-components";
import {
  ArrowLeftRegular,
  ArrowRightRegular,
  FilterRegular,
} from "@fluentui/react-icons";
import { useVaultMeetingsToolbarStyles } from "./VaultMeetingsToolbar.styles";
import { IVaultMeetingsToolbarProps } from "./VaultMeetingsToolbar.types";

export const VaultMeetingsToolbar = ({
  weekRangeLabel,
  summaryText,
  isCurrentWeek,
  activeFilterCount,
  isFilterBandOpen,
  filterBandId,
  onPreviousWeek,
  onNextWeek,
  onToday,
  onToggleFilters,
}: IVaultMeetingsToolbarProps): JSX.Element => {
  const styles = useVaultMeetingsToolbarStyles();

  return (
    <div className={styles.root} role="group" aria-label="Week navigation">
      <Button
        appearance="outline"
        className={styles.button}
        icon={<ArrowLeftRegular aria-hidden="true" />}
        aria-label="Previous week"
        onClick={onPreviousWeek}
      />
      <span
        className={styles.weekLabel}
        data-testid="vault-meetings-week-label"
      >
        {weekRangeLabel}
      </span>
      <Button
        appearance="outline"
        className={styles.button}
        icon={<ArrowRightRegular aria-hidden="true" />}
        aria-label="Next week"
        onClick={onNextWeek}
      />
      <Button
        appearance="outline"
        className={styles.button}
        disabled={isCurrentWeek}
        onClick={onToday}
      >
        Today
      </Button>
      <Button
        appearance="outline"
        className={styles.button}
        icon={<FilterRegular aria-hidden="true" />}
        aria-expanded={isFilterBandOpen}
        aria-controls={isFilterBandOpen ? filterBandId : undefined}
        onClick={onToggleFilters}
      >
        {activeFilterCount > 0 ? `Filters (${activeFilterCount})` : "Filters"}
      </Button>
      <span className={styles.spacer} />
      <span className={styles.summary} role="status">
        {summaryText}
      </span>
    </div>
  );
};
